export default "__VITE_ASSET__CGd2Zl33__"